import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { takeUntil } from 'rxjs/operators';
import { AuthServiceService } from 'src/app/shared/services/auth-service.service';
import { OthersService } from 'src/app/shared/services/other-services/others.service';
import { CustomValidator } from 'src/app/validators/custom-validator';
import { LoanActionObject } from "../../../../shared/components/loan-report/loan-report.component";
import {PageEvent} from "@angular/material/paginator";

// noinspection SillyAssignmentJS
@Component({
  selector: 'app-areas',
  templateUrl: './areas.component.html',
  styleUrls: ['./areas.component.scss']
})
export class AreasComponent implements OnInit {
  public modalRef: BsModalRef;
  posted: boolean;
  errored: boolean;
  userForm: FormGroup;
  user = '/../../../assets/img/man.svg';
  type: string;
  reports = [
    'All Loans', 'Completed Loans',
    'Bodaboda Loan', 'Taxi Loan', 'Micro Loan',
    'Bodaboda Defaulters', 'Taxi Defaulters', 'Micro Defaulters',
    'Bodaboda Recovery', 'Taxi Recovery', 'Micro Recovery',
    'Bodaboda Enforcement', 'Taxi Enforcement', 'Micro Enforcement',
    'Float Deposits', 'Revenue Ledger', 'Lost Revenue',
    'Cash Ledger', 'Paid Ledger', 'Borrowed Ledger',
    'Individuals Savings', 'General Savings Balances', 'General Savings',
    'Float Withdraws', 'Float Deposit & Withdraw', 'Waived Principal', 'Reversed Principal',
    'Waived Interest', 'Interest', 'Float Balance Per Day', 'Commission',
    'Micro Loan Guarantor', 'Micro Loan Security',
    'Micro Loan Amortization',
    'Reversed Interest', 'All Loan Principal'
  ];
  User = this.authService.loggedInUserInfo();
  singleReport: any;
  reportsCopy: any;
  imageUrl: string;
  totals: any;
  stationName: string;
  locations: any;
  locationId: any;
  level: any;
  areas: any;
  towns: any;
  stations: any;
  select: string;
  p: number;
  total: number;
  customers: any;
  phoneNumbers: any;
  checkedClient: any;
  locationName = this.User.userLocationName;
  locationVal: number;
  microLoanProp: LoanActionObject;
  selectionKind: number;
  selectionData: any;
  modalTitle: string;
  lowValue: number = 0;
  highValue: number = 10;
  pageSize: number = 10;
  constructor(
    private fb: FormBuilder,
    private modalService: BsModalService,
    private authService: AuthServiceService,
    private others: OthersService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private alertService: AlertService,
  ) { }

  ngOnInit(): void {
    this.total = 0;
    this.reports.sort();
    this.others.getAllTheStationLocations().subscribe(
      res => this.stations = res,
      err => {
        //  //console.log(err)
      }
    );
    this.others.getAllTheTownLocations().subscribe(
      res => this.towns = res,
      err => {
        //  //console.log(err)
      }
    );
    this.others.getAllTheAreaLocations().subscribe(
      res => this.areas = res,
      err => {
        //  //console.log(err)
      }
    );
    this.others.getSavingsCustomers().subscribe(
      (res) => {
        if (res.length > 0) {
          this.customers = res;
          this.phoneNumbers = [];
          this.checkedClient = {};
          this.customers.forEach((customer) => {
            this.phoneNumbers.push(customer.customerPhone1);
          });
        }
      },
      (err) => {
        this.errored = true;
        this.errored = true;
        this.alertService.danger({
          html: '<b>' + err + '</b>'
        });
        this.alertService.danger({
          html: '<b>' + err + '</b>',
        });
      }
    );
    this.userForm = this.createFormGroup();
    this.select = 'place holder';
    this.pageSize = 10;
  }

  getResult(res: any): void {
    this.checkedClient = res;
    this.modalRef.hide();
  }
  getClose(res: any): void {
    this.modalRef.hide();
  }

  selectFromData(template: TemplateRef<any>, kind: number): void {
    if (kind === 100) {
      this.openModal(template);
      this.selectionKind = kind;
      this.selectionData = this.customers;
      this.modalTitle = "Select a Client";
    }
  }

  public getPaginatorData(event: PageEvent): PageEvent {
    this.lowValue = event.pageIndex * event.pageSize;
    this.highValue = this.lowValue + event.pageSize;
    return event;
  }

  pageSizeOptions() {
    return [5, 10, 20, 30, 40, 50, this.singleReport?.length].filter(n => n <= this.singleReport?.length)
  }

   createFormGroup(): any {
    return this.fb.group({
      report_type: this.fb.control('', Validators.compose([])),
      search_by: this.fb.control({value: '', disabled: true}, Validators.compose([])),
      location: this.fb.control({value: '', disabled: true}, Validators.compose([])),
      range_date: this.fb.control({value: '', disabled: true}, Validators.compose([])),
    });
  }
  get fval(): any {
    return this.userForm.controls;
  }
  loanActions(action: LoanActionObject): any {
    this.microLoanProp = action;
    this.fval.report_type.setValue("Specify Type");
    this.singleReport = [];
    this.totals = {};
    this.p = 1;
    this.total = 0;
    switch (action.type) {
      case "amortization":
        this.total = 0;
        this.others.microloanAmortizationSchedule(Number(action.id)).subscribe(
          res => {
            this.type = "Micro Loan Amortization";
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
              this.total = this.singleReport.length;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case "security":

        this.others.getIndividualMircroLoanSecurity(Number(action.id)).subscribe(
          res => {
            this.type = "Individual Micro Loan Security";
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
              this.total = this.singleReport.length;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case "Guarantors":
        this.total = 0
        this.others.getIndividualMicroloanGuarantors(Number(action.id)).subscribe(
          res => {
            this.type = "Individual Loan Guarantor"
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
              this.total = this.singleReport.length;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case "Statement":
        this.type = "Loan Statement";
        this.others.getLoanStatement(Number(action.id)).subscribe(
          res => {
            this.singleReport = res;
            this.reportsCopy = res;
            this.total = this.singleReport.length;
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
      case "Accrued":
        this.type = "Interest Accrual";
        this.others.microloanAmortizationSchedule(Number(action.id)).subscribe(
          res => {
            if (res.length === 1) {
              this.totals = res[0];
              this.singleReport = [];
            } else {
              this.totals = res.pop();
              this.singleReport = res;
              this.reportsCopy = res;
              this.total = this.singleReport.length;
            }
          },
          err => {
            this.errored = true;
            this.alertService.danger({
              html: '<b>' + err + '</b>'
            });
          }
        );
        break;
    }
  }
  changeLevels(val: string): any {
    this.fval.location.reset();
    switch (val) {
      case 'Region':
        this.level = val;
        this.select = `select a ${val}`;
        this.locations = this.areas;
        break;
      case 'Town':
        this.level = val;
        this.select = `select a ${val}`;
        this.locations = this.towns;
        break;
      case 'Station':
        this.level = val;
        this.select = `select a ${val}`;
        this.locations = this.stations;
        break;
      case 'General':
        this.level = 'General';
        this.select = `select a ${val}`;
        this.locationName = this.User.userLocationName;
        this.locations = [];
    }
  }
  getReportsCopy() {
    return this.reportsCopy || []
  }

  searchResponse(result: any): any {
    if (result.length) this.singleReport = result;
    else this.singleReport = this.reportsCopy;
    this.total = this.singleReport.length
  }

  changeReport(val: any): any {
    // console.log(val);
    this.singleReport = [];
    this.totals = {};
    this.p = 1;
    this.total = 0;
    this.type = val;
    this.level = 'General';
    this.fval.search_by.setValue('General');
    this.fval.location.reset();
    this.locationName = this.User.userLocationName;
    this.changeLevels('General');
    this.locationVal = null;
    const date = new Date();
    const startDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    const endDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    this.fetchReports([startDate, endDate], this.type);
    if(this.type !== "Individuals Savings") {
      this.fval.search_by.enable();
      this.fval.location.enable();
    } else {
      this.fval.search_by.disable();
      this.fval.location.disable();
    }

    if (
      this.type === 'Cash Ledger' ||
      this.type === 'Borrowed Ledger' ||
      this.type === 'Paid Ledger' ||
      this.type === 'Commission' ||
      this.type === 'Individuals Savings' ||
      this.type === 'Float Deposits' ||
      this.type === 'Float Withdraws' ||
      this.type === 'Float Deposit & Withdraw' ||
      this.type === 'General Savings' ||
      this.type === 'Float Balance Per Day')
    {
      this.fval.range_date.enable()
    } else {
      this.fval.range_date.disable()
    }

    if(this.type === 'Specify Type') {
      this.fval.search_by.disable();
      this.fval.location.disable();
      this.fval.range_date.disable()
    }
  }
  fetchReport(val: any): any {
    const date = new Date();
    let startDate: string;
    let endDate: string;
    if (val.length > 1) {
      startDate = `${val[0].getFullYear()}-${val[0].getMonth() + 1}-${val[0].getDate()}`;
      endDate = `${val[1].getFullYear()}-${val[1].getMonth() + 1}-${val[1].getDate()}`;
      //this.spinner.show;;
      this.fetchReports([startDate, endDate], this.type);
    } else {
      startDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      endDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      //this.spinner.show;;
      this.fetchReports([startDate, endDate], this.type);
    }
  }
  fetchReports(dates: Array<string>, typeOfReport: string): any {
    this.singleReport = [];
    this.totals = {};
    this.total = 0
    this.locationVal = Number.parseInt(this.userForm.controls.location.value, 10);
    switch (this.level) {
      case 'Region':
        this.areas.forEach(area => {
          // console.log(this.locationVal);
          if (area.theAreaLocationId === this.locationVal) {
            this.locationName = area.areaRegionName;
          }
        });
        break;
      case 'Town':
        this.towns.forEach(town => {
          if (town.theTownLocationId === this.locationVal) {
            this.locationName = town.townName;
          }
        });
        break;
      case 'Station':
        this.stations?.forEach(station => {
          if (station.theStationLocationId === this.locationVal) {
            this.locationName = station.stationName;
          }
        });
        break;
      case 'General':
        this.locationName = this.locationName;
        this.locationVal = null;
        break;
    }
    switch (typeOfReport) {
      case 'Cash Ledger':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getCashLedgerArea({
                theAreaLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getCashLedgerTown({
                theTownLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getCashLedgerStation({
                theStationLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        }
        break;
      case 'Borrowed Ledger':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getBorrowedLedgerArea({
                theAreaLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getBorrowedLedgerTown({
                theTownLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getBorrowedLedgerStation({
                theStationLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        }
        break;
      case 'Paid Ledger':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getPaidLedgerArea({
                theAreaLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getPaidLedgerTown({
                theTownLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getPaidLedgerStation({
                theStationLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        }
        break;
      case 'All Loans':
        this.p = 1;
        this.total = 0;
        // console.log(this.locationVal);
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getAllLoansByRegion(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getAllLoansByTown(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getAllLoansByStation(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getAllLoans().subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Revenue Ledger':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getAllRevenueArea({
                theAreaLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getAllRevenueTown({
                theTownLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getAllRevenueStation({
                theStationLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getAllRevenue({
            startDate: dates[0],
            endDate: dates[1],
          }).subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Bodaboda Loan':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getAllBodaBodaLoansByRegion(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getAllBodaBodaLoansByTown(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getAllBodaBodaLoansByStation(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getAllBodaBodaLoans().subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Taxi Loan':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getAllTaxiLoansByRegion(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getAllTaxiLoansByTown(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getAllTaxiLoansByStation(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getAllTaxiLoans().subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Micro Loan':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getAllMicroLoansByRegion(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getAllMicroLoansByTown(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getAllMicroLoansByStation(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getAllMicroLoans().subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Commission':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getCommisionArea({
                theAreaLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getCommisionTown({
                theTownLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getCommisionStation({
                theStationLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getAllCommision({
            startDate: dates[0],
            endDate: dates[1],
          }).subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Float Balance Per Day':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getFloatBalancePerDayByRegion({
                theAreaLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    // this.totals = res[0];
                    this.singleReport = res;
                    this.reportsCopy = res;
                  } else {
                    // this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getFloatBalancePerDayByTown({
                theTownLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    // this.totals = res[0];
                    this.singleReport = res;
                    this.reportsCopy = res;
                  } else {
                    // this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getFloatBalancePerDayByStation({
                theStationLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    // this.totals = res[0];
                    this.singleReport = res;
                    this.reportsCopy = res;
                  } else {
                    // this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getFloatBalancePerDay({
            startDate: dates[0],
            endDate: dates[1],
          }).subscribe(
            res => {
              if (res.length === 1) {
                // this.totals = res[0];
                this.singleReport = res;
                this.reportsCopy = res;
              } else {
                // this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Float Deposit & Withdraw':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getFloatDepositAndWithdrawByRegion({
                theAreaLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getFloatDepositAndWithdrawByTown({
                theTownLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getFloatDepositAndWithdrawByStation({
                theStationLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getFloatDepositAndWithdraw({
            startDate: dates[0],
            endDate: dates[1],
          }).subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Float Deposits':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getFloatDepositByRegion({
                theAreaLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getFloatDepositByTown({
                theTownLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getFloatDepositByStation({
                theStationLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getFloatDeposit({
            startDate: dates[0],
            endDate: dates[1],
          }).subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Float Withdraws':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getFloatWithdrawalByRegion({
                theAreaLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getFloatWithdrawalByTown({
                theTownLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getFloatWithdrawalByStation({
                theStationLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getFloatWithdrawal({
            startDate: dates[0],
            endDate: dates[1],
          }).subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Individuals Savings':
        this.p = 1;
        this.total = 0;
        if (this.checkedClient.customerPhone1) {
            this.others.getIndivisualSavings({
              customerPhone1: this.checkedClient.customerPhone1,
              startDate: dates[0],
              endDate: dates[1],
            }).subscribe(
              res => {
                if (res.length === 1) {
                  this.totals = res[0];
                  this.singleReport = [];
                } else {
                  this.totals = res.pop();
                  this.singleReport = res;
                  this.reportsCopy = res;
                  this.total = this.singleReport.length;
                }
              },
              err => {
                this.errored = true;
                this.alertService.danger({
                  html: '<b>' + err + '</b>'
                });
              }
            );
          } else {
            this.errored = true;
            this.alertService.danger({
              html: 'The Phone number is not registered',
            });
            this.singleReport = [];
            this.totals = {
              savingsRemoved: 0,
              savingsBalance: 0,
              savingsAdded: 0
            };
          }
        break;
      case 'General Savings':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getGeneralSavingsByRegion({
                theAreaLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getGeneralSavingsByTown({
                theTownLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getGeneralSavingsByStation({
                theStationLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getGeneralSavings({
            startDate: dates[0],
            endDate: dates[1],
          }).subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'General Savings Balances':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getGeneralSavingsBalancesByRegion(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getGeneralSavingsBalancesByTown(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getGeneralSavingsBalancesByStation(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getGeneralSavingsBalances().subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Completed Loans':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getAllCompletedLoansByRegion(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getAllCompletedLoansByTown(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getAllCompletedLoansByStation(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getAllCompletedLoans().subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Bodaboda Defaulters':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getAllBodaBodaLoanDefaultersByRegion(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getAllBodaBodaLoanDefaultersByTown(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getAllBodaBodaLoanDefaultersByStation(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getAllBodaBodaLoanDefaulters().subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Taxi Defaulters':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getAllTaxiLoanDefaultersByRegion(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getAllTaxiLoanDefaultersByTown(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getAllTaxiLoanDefaultersByStation(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getAllTaxiLoanDefaulters().subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Micro Defaulters':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getAllMicroLoanDefaultersByRegion(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getAllMicroLoanDefaultersByTown(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getAllMicroLoanDefaultersByStation(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getAllMircoLoanDefaulters().subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Bodaboda Recovery':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getAllBodaBodaLoanRecoveryByRegion(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getAllBodaBodaLoanRecoveryByTown(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getAllBodaBodaLoanRecoveryByStation(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getAllBodaBodaLoanRecovery().subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Taxi Recovery':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getAllTaxiLoanRecoveryByRegion(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getAllTaxiLoanRecoveryByTown(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getAllTaxiLoanRecoveryByStation(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getAllTaxiLoanRecovery().subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Micro Recovery':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getAllMicroLoanRecoveryByRegion(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getAllMicroLoanRecoveryByTown(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getAllMicroLoanRecoveryByStation(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getAllMircoLoanRecovery().subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Bodaboda Enforcement':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getAllBodaBodaLoanEnforcementByRegion(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getAllBodaBodaLoanEnforcementByTown(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getAllBodaBodaLoanEnforcementByStation(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getAllBodaBodaLoanEnforcement().subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Taxi Enforcement':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getAllTaxiLoanEnforcementByRegion(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getAllTaxiLoanEnforcementByTown(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getAllTaxiLoanEnforcementByStation(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getAllTaxiLoanEnforcement().subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Micro Enforcement':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getAllMicroLoanEnforcementByRegion(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getAllMicroLoanEnforcementByTown(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getAllMicroLoanEnforcementByStation(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getAllMircoLoanEnforcement().subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Interest':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getInterestOnlyByRegion(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getInterestOnlyByTown(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getInterestOnlyByStation(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getInterestOnly().subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'All Loan Principal':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getLoanPrincipalOnlyByRegion(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getLoanPrincipalOnlyByTown(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getLoanPrincipalOnlyByStation(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getLoanPrincipalOnly().subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Micro Loan Security':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getMicroloanSecurityByRegion(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getMicroloanSecurityByTown(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getMicroloanSecurityByStation(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getMicroloanSecurity().subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Micro Loan Guarantor':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getMicroloanGaurantorsByRegion(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getMicroloanGaurantorsByTown(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getReversedInterestByStation(this.locationVal).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getMicroloanGaurantors().subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Lost Revenue':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getAllLostRevenueArea({
                theAreaLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getAllLostRevenueTown({
                theTownLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getAllLostRevenueStation({
                theStationLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getAllLostRevenue({
            startDate: dates[0],
            endDate: dates[1],
          }).subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Reversed Interest':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getReversedInterestByRegion({
                theAreaLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getReversedInterestByTown({
                theTownLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getReversedInterestByStation({
                theStationLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getReversedInterest({
            startDate: dates[0],
            endDate: dates[1],
          }).subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Reversed Principal':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getReversedPrincimpalByRegion({
                theAreaLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getReversedPrincimpalByTown({
                theTownLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getReversedPrincimpalByStation({
                theStationLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getReversedPrincimpal({
            startDate: dates[0],
            endDate: dates[1],
          }).subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Waived Interest':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getWavedInterestByRegion({
                theAreaLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getWavedInterestByTown({
                theTownLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getWavedInterestByStation({
                theStationLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getWavedInterest({
            startDate: dates[0],
            endDate: dates[1],
          }).subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
      case 'Waived Principal':
        this.p = 1;
        this.total = 0;
        if (this.locationVal) {
          switch (this.level) {
            case 'Region':
              this.others.getWavedPrincimpalByRegion({
                theAreaLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Town':
              this.others.getWavedPrincimpalByTown({
                theTownLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
            case 'Station':
              this.others.getWavedPrincimpalByStation({
                theStationLocationId: this.locationVal,
                startDate: dates[0],
                endDate: dates[1],
              }).subscribe(
                res => {
                  if (res.length === 1) {
                    this.totals = res[0];
                    this.singleReport = [];
                  } else {
                    this.totals = res.pop();
                    this.singleReport = res;
                    this.reportsCopy = res;
                    this.total = this.singleReport.length;
                  }
                },
                err => {
                  this.errored = true;
                  this.alertService.danger({
                    html: '<b>' + err + '</b>'
                  });
                }
              );
              break;
          }
        } else {
          this.others.getWavedPrincimpal({
            startDate: dates[0],
            endDate: dates[1],
          }).subscribe(
            res => {
              if (res.length === 1) {
                this.totals = res[0];
                this.singleReport = [];
              } else {
                this.totals = res.pop();
                this.singleReport = res;
                this.reportsCopy = res;
                this.total = this.singleReport.length;
              }
            },
            err => {
              this.errored = true;
              this.alertService.danger({
                html: '<b>' + err + '</b>'
              });
            }
          );
        }
        break;
    }
    this.spinner.hide();
  }
  public openModal(template: TemplateRef<any>, photoUrl?: string): any {
    this.imageUrl = photoUrl;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'modal-dialog-centered' })
    );
  }
  pageChanged(event): any {
    this.p = event;
  }
}
